import { ReactNode, useCallback, useState } from 'react';
import { Columns, Element, Section } from 'react-bulma-components';
import { Outlet, useNavigate } from 'react-router-dom';
import BackButton from '../../shared/back-button/back-button';
import If from '../../shared/if/if';
import BoxLayout from '../../ui/box-layout/box-layout';
import { SalesOrdersAccessStorageService } from '../sales-orders-access-storage-service';
import { CustomerAccessSetupSteps } from './types';

const customerAccessSalesOrdersSessionStorageService =
  new SalesOrdersAccessStorageService();

export function AdminCustomerAccessSetupPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState<number>(1);
  const [headerButton, setHeaderButton] = useState<ReactNode>();

  const resetData = useCallback(() => {
    customerAccessSalesOrdersSessionStorageService.remove();
  }, []);

  const handleBackButtonClick = useCallback(() => {
    switch (step) {
      case CustomerAccessSetupSteps.SALES_ORDERS:
        resetData();
        navigate('/admin/temporary-access');
        break;
      case CustomerAccessSetupSteps.USER:
        navigate('/admin/customer-access/setup/sales-orders');
        break;
    }
  }, [navigate, resetData, step]);

  const Header = useCallback(() => {
    return (
      <Element className="p-4">
        <Section paddingless>
          <BackButton onClick={handleBackButtonClick} />
          <Columns>
            <Columns.Column>
              <h1 className="is-size-3 has-text-weight-light">
                Add customer roles
              </h1>
              <If condition={step === CustomerAccessSetupSteps.SALES_ORDERS}>
                <h2 className="is-size-5 has-text-weight-light">
                  Select the Sales Orders you want to grant new customer
                  permissions to. Keep in mind this flow is not for zSpace
                  support roles
                </h2>
              </If>
            </Columns.Column>
            <If condition={!!headerButton}>
              <Columns.Column
                className="is-narrow"
                display="flex"
                justifyContent="flex-end"
              >
                {headerButton}
              </Columns.Column>
            </If>
          </Columns>
        </Section>
      </Element>
    );
  }, [handleBackButtonClick, headerButton, step]);

  return (
    <BoxLayout className="is-min-height-80 mx-10 my-4" flex header={<Header />}>
      <Outlet context={{ setStep, setHeaderButton }} />
    </BoxLayout>
  );
}

export default AdminCustomerAccessSetupPage;
